<div class="cb-dialog" [ngClass]="'cb-dialog-from-'+alignment()" [attr.data-theme]="theme">
    <div [@backdropAnimation]="closing() ? 'closed' : 'opened'" class="cb-dialog-backdrop" (click)="backdropClick()">
    </div>
    <div role="dialog" #DialogWrapper [@dialogAnimation]="(closing())? 'closed' : alignment()" class="cb-dialog-wrapper"
        [style.width]="width()" [style.height]="height()">
    </div>
</div>